import type { ComponentProps } from 'react';
import { match } from 'ts-pattern';

type Props = {
  variant?: 'muted' | 'active' | 'primary' | 'fill';
} & ComponentProps<'svg'>;

export const StatusIcon = ({ variant = 'muted', ...rest }: Props) =>
  match(variant)
    .with('muted', () => (
      <svg
        width={rest.width ?? 16}
        height={rest.height ?? 16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <mask
          id="mask0_420_44"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={rest.width ?? 16}
          height={rest.height ?? 16}
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_420_44)">
          <path
            d="M8.5 3.01825C7.47872 2.93079 6.38185 3.15931 5.49477 3.6729C4.6077 4.18648 3.89991 4.96029 3.46725 5.88952C3.03459 6.81875 2.89798 7.85851 3.07592 8.86796C3.25385 9.87742 3.73774 10.8078 4.46203 11.5331C5.18633 12.2584 6.11605 12.7436 7.12526 12.9229C8.13447 13.1022 9.17441 12.967 10.1042 12.5357C11.0341 12.1043 11.8088 11.3976 12.3237 10.5112C12.8385 9.62483 13.0684 8.60166 12.9824 7.58026C12.9824 7.58026 12.6131 7.78914 12.3237 7.87111C12.0342 7.95307 11.5 8.00001 11.5 8.00001C11.5602 8.71495 11.3867 9.13731 11.0264 9.75772C10.666 10.3781 10.1237 10.8728 9.47287 11.1748C8.82204 11.4767 8.09412 11.5713 7.38772 11.4458C6.68132 11.3203 6.03056 10.9807 5.52358 10.473C5.0166 9.96534 4.67791 9.31411 4.55336 8.60754C4.42881 7.90096 4.52443 7.17318 4.82728 6.52276C5.13012 5.87233 5.62554 5.3307 6.24645 4.97122C6.86737 4.61173 7.28515 4.4388 8 4.50001C8 4.50001 8.03518 4.08231 8.13281 3.79298C8.23044 3.50365 8.5 3.01825 8.5 3.01825Z"
            fill="#646467"
          />
          <path
            d="M11.3333 6.66663C12.4379 6.66663 13.3333 5.7712 13.3333 4.66663C13.3333 3.56206 12.4379 2.66663 11.3333 2.66663C10.2288 2.66663 9.33334 3.56206 9.33334 4.66663C9.33334 5.7712 10.2288 6.66663 11.3333 6.66663Z"
            fill="#646467"
          />
        </g>
      </svg>
    ))
    .with('active', () => (
      <svg
        width={rest.width ?? 16}
        height={rest.height ?? 16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <mask
          id="mask0_420_44"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={rest.width ?? 16}
          height={rest.height ?? 16}
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_420_44)">
          <path
            d="M8.5 3.01825C7.47872 2.93079 6.38185 3.15931 5.49477 3.6729C4.6077 4.18648 3.89991 4.96029 3.46725 5.88952C3.03459 6.81875 2.89798 7.85851 3.07592 8.86796C3.25385 9.87742 3.73774 10.8078 4.46203 11.5331C5.18633 12.2584 6.11605 12.7436 7.12526 12.9229C8.13447 13.1022 9.17441 12.967 10.1042 12.5357C11.0341 12.1043 11.8088 11.3976 12.3237 10.5112C12.8385 9.62483 13.0684 8.60166 12.9824 7.58026C12.9824 7.58026 12.6131 7.78914 12.3237 7.87111C12.0342 7.95307 11.5 8.00001 11.5 8.00001C11.5602 8.71495 11.3867 9.13731 11.0264 9.75772C10.666 10.3781 10.1237 10.8728 9.47287 11.1748C8.82204 11.4767 8.09412 11.5713 7.38772 11.4458C6.68132 11.3203 6.03056 10.9807 5.52358 10.473C5.0166 9.96534 4.67791 9.31411 4.55336 8.60754C4.42881 7.90096 4.52443 7.17318 4.82728 6.52276C5.13012 5.87233 5.62554 5.3307 6.24645 4.97122C6.86737 4.61173 7.28515 4.4388 8 4.50001C8 4.50001 8.03518 4.08231 8.13281 3.79298C8.23044 3.50365 8.5 3.01825 8.5 3.01825Z"
            fill="#546195"
          />
          <path
            d="M11.3333 6.66663C12.4379 6.66663 13.3333 5.7712 13.3333 4.66663C13.3333 3.56206 12.4379 2.66663 11.3333 2.66663C10.2288 2.66663 9.33334 3.56206 9.33334 4.66663C9.33334 5.7712 10.2288 6.66663 11.3333 6.66663Z"
            fill="#546195"
          />
        </g>
      </svg>
    ))
    .with('primary', () => (
      <svg
        width={rest.width ?? 16}
        height={rest.height ?? 16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <mask
          id="mask0_420_44"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={rest.width ?? 16}
          height={rest.height ?? 16}
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_420_44)">
          <path
            d="M8.5 3.01825C7.47872 2.93079 6.38185 3.15931 5.49477 3.6729C4.6077 4.18648 3.89991 4.96029 3.46725 5.88952C3.03459 6.81875 2.89798 7.85851 3.07592 8.86796C3.25385 9.87742 3.73774 10.8078 4.46203 11.5331C5.18633 12.2584 6.11605 12.7436 7.12526 12.9229C8.13447 13.1022 9.17441 12.967 10.1042 12.5357C11.0341 12.1043 11.8088 11.3976 12.3237 10.5112C12.8385 9.62483 13.0684 8.60166 12.9824 7.58026C12.9824 7.58026 12.6131 7.78914 12.3237 7.87111C12.0342 7.95307 11.5 8.00001 11.5 8.00001C11.5602 8.71495 11.3867 9.13731 11.0264 9.75772C10.666 10.3781 10.1237 10.8728 9.47287 11.1748C8.82204 11.4767 8.09412 11.5713 7.38772 11.4458C6.68132 11.3203 6.03056 10.9807 5.52358 10.473C5.0166 9.96534 4.67791 9.31411 4.55336 8.60754C4.42881 7.90096 4.52443 7.17318 4.82728 6.52276C5.13012 5.87233 5.62554 5.3307 6.24645 4.97122C6.86737 4.61173 7.28515 4.4388 8 4.50001C8 4.50001 8.03518 4.08231 8.13281 3.79298C8.23044 3.50365 8.5 3.01825 8.5 3.01825Z"
            fill="#00082C"
            fillOpacity="0.9"
          />
          <path
            d="M11.3333 6.66663C12.4379 6.66663 13.3333 5.7712 13.3333 4.66663C13.3333 3.56206 12.4379 2.66663 11.3333 2.66663C10.2288 2.66663 9.33334 3.56206 9.33334 4.66663C9.33334 5.7712 10.2288 6.66663 11.3333 6.66663Z"
            fill="#00082C"
            fillOpacity="0.9"
          />
        </g>
      </svg>
    ))
    .with('fill', () => (
      <svg
        width={rest.width ?? 16}
        height={rest.height ?? 16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <mask
          id="mask0_420_44"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={rest.width ?? 16}
          height={rest.height ?? 16}
        >
          <rect
            width={rest.width ?? 16}
            height={rest.height ?? 16}
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_420_44)">
          <path
            d="M8.5 3.01825C7.47872 2.93079 6.38185 3.15931 5.49477 3.6729C4.6077 4.18648 3.89991 4.96029 3.46725 5.88952C3.03459 6.81875 2.89798 7.85851 3.07592 8.86796C3.25385 9.87742 3.73774 10.8078 4.46203 11.5331C5.18633 12.2584 6.11605 12.7436 7.12526 12.9229C8.13447 13.1022 9.17441 12.967 10.1042 12.5357C11.0341 12.1043 11.8088 11.3976 12.3237 10.5112C12.8385 9.62483 13.0684 8.60166 12.9824 7.58026C12.9824 7.58026 12.6131 7.78914 12.3237 7.87111C12.0342 7.95307 11.5 8.00001 11.5 8.00001C11.5602 8.71495 11.3867 9.13731 11.0264 9.75772C10.666 10.3781 10.1237 10.8728 9.47287 11.1748C8.82204 11.4767 8.09412 11.5713 7.38772 11.4458C6.68132 11.3203 6.03056 10.9807 5.52358 10.473C5.0166 9.96534 4.67791 9.31411 4.55336 8.60754C4.42881 7.90096 4.52443 7.17318 4.82728 6.52276C5.13012 5.87233 5.62554 5.3307 6.24645 4.97122C6.86737 4.61173 7.28515 4.4388 8 4.50001C8 4.50001 8.03518 4.08231 8.13281 3.79298C8.23044 3.50365 8.5 3.01825 8.5 3.01825Z"
            fill="white"
          />
          <path
            d="M11.3333 6.66663C12.4379 6.66663 13.3333 5.7712 13.3333 4.66663C13.3333 3.56206 12.4379 2.66663 11.3333 2.66663C10.2288 2.66663 9.33334 3.56206 9.33334 4.66663C9.33334 5.7712 10.2288 6.66663 11.3333 6.66663Z"
            fill="white"
          />
        </g>
      </svg>
    ))
    .exhaustive();
